import React from "react";
import "./searchBar.css";

const SearchBar = ({
  handleSearch,
  handleSearchSubmit,
  handleKeyPress,
  searchTerm,
  setSearchTerm,
  placeholder = "ابحث هنا",
}) => {
  // Handle input change without automatic search
  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    // Only update the input value, don't trigger search
  };

  // Handle search button click
  const handleSearchClick = () => {
    handleSearchSubmit();
  };

  // Handle enter key press
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
    // Also call the external handleKeyPress if provided
    if (handleKeyPress) {
      handleKeyPress(e);
    }
  };

  return (
    <div className="searchBar-container">
      <div className="ratingsReport-search">
        <div className="input-box">
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="search-icon" onClick={handleSearchClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none"
          >
            <path
              d="M28.7875 28.7353L36 36M32.6667 19.3333C32.6667 26.6972 26.6972 32.6667 19.3333 32.6667C11.9695 32.6667 6 26.6972 6 19.3333C6 11.9695 11.9695 6 19.3333 6C26.6972 6 32.6667 11.9695 32.6667 19.3333Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
